import React from 'react';
import '../css/TestimonialsPage.css';

const TestimonialsPage = () => {
    return (
        <div className="testimonials-page">
            <section className="testimonials-hero">
                <div className="testimonials-hero-content">
                    <span className="testimonials-section-label">Testimonials</span>
                    <h1>What Our Clients Say</h1>
                    <p>
                        We measure our success by the impact we create for the businesses we work with.
                        Here's what our clients have to say.
                    </p>
                </div>
            </section>

            <section className="testimonials-section">
                <div className="testimonials-container">
                    <div className="testimonials-empty">
                        <div className="testimonials-empty-icon">💬</div>
                        <h2>Be Our First!</h2>
                        <p>
                            We're just getting started. Work with us and let us know how we did —
                            your feedback could be the first story we share here.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TestimonialsPage;
